import { render, staticRenderFns } from "./WorkItemForm.vue?vue&type=template&id=03d89afd&scoped=true"
import script from "./WorkItemForm.vue?vue&type=script&lang=js"
export * from "./WorkItemForm.vue?vue&type=script&lang=js"
import style0 from "./WorkItemForm.vue?vue&type=style&index=0&id=03d89afd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d89afd",
  null
  
)

export default component.exports